import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './config';
import less from "less";
import "@/assets/global.less";
import "@/utils/tip";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import hasClipboard from "@/utils/HasClipboard";
import Storage from "vue-ls";
import VConsole from 'vconsole'
if (process.env.VUE_APP_WEB_ENV !== "prod") {
  const vconsole = new VConsole()
}

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);
Vue.use(less);
Vue.use(hasClipboard);
Vue.use(Storage, {
  namespace: "sd__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
});
/**********v-viewer**********/
Vue.use(Viewer, {
  defaultOptions: {
    navbar: false,
    toolbar: true,
    title: false,
    scalable: false,
  },
});
/**********v-viewer**********/

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
